let biasData = [];

biasData = [
    {
        title: "Video",
        description: "Watch a video about AI Bias.",
        link: "https://cdnapisec.kaltura.com/index.php/extwidget/preview/partner_id/684682/uiconf_id/31013851/entry_id/1_h556oikg/embed/dynamic"
    },
    {
        title: "AI Bias complexities",
        description: "Learn about the complexity of biased AI.",
        link: "https://www.nist.gov/news-events/news/2022/03/theres-more-ai-bias-biased-data-nist-report-highlights"
    },
    {
        title: "Gender Bias",
        description: "Read about gender bias in AI",
        link: "https://www.msnbc.com/know-your-value/feature/artificial-intelligence-has-gender-problem-why-it-matters-everyone-ncna1097141"
    },
    {
        title: "Housing",
        description: "See how AI Bias could affect housing.",
        link: "https://www.axios.com/2019/09/04/proposed-hud-rule-on-ai-could-allow-for-housing-discrimination"
    },
    {
        title: "Facial Recgonition",
        description: "See how AI Bias affects facial recognition.",
        link: "https://garage.hp.com/us/en/modern-life/Artificial-intelligence-bias-face-recognition.html"
    },
    {
        title: "Healthcare bias",
        description: "See how AI bias affects healthcare",
        link: "https://www.axios.com/2019/05/01/how-bias-creeps-into-health-care-ai"
    },
    {
        title: "Gorillas",
        description: "See a real-life example of an AI biased by race.",
        link: "https://www.npr.org/2021/09/04/1034368231/facebook-apologizes-ai-labels-black-men-primates-racial-bias"
    },
    {
        title: "Attorney/Paralegal",
        description: "See a real-life example of an AI biased by gender.",
        link: "https://twitter.com/Eodyne1/status/1650632232212520960"
    },
    {
        title: "Doctor/Nurse",
        description: "See a real-life example of an AI biased by gender.",
        link: "https://twitter.com/HadasKotek/status/1648453764117041152"
    }
    ]


export default biasData;
